import { Drawing } from "./drawing";
import { Matrix } from "../base/matrix";
import { Pt } from "../base/pt";
import { Chain } from "../base/chain";
import { Element } from "./svg";

class Group extends Drawing {
  drawings: Drawing[];

  constructor(color: string, drawings: Drawing[], labels: Map<string, Pt>, anchorPt?: Pt) {
    super(color, labels, anchorPt);
    this.drawings = drawings;
  }

  transform(matrix: Matrix): Group {
    return new Group(
      this.color,
      this.drawings.map((s) => s.transform(matrix)),
      this.transformLabels(matrix),
      this.transformAnchor(matrix)
    );
  }

  label(name: string, pt: Pt): Group {
    const newLabels = new Map(this.labels);
    newLabels.set(name, pt);
    return new Group(this.color, this.drawings, newLabels, this.anchorPt);
  }

  anchorAt(pt: Pt): Group {
    return new Group(this.color, this.drawings, this.labels, pt)
  }

  stroke(color: string): Group {
    return new Group(color, this.drawings, this.labels, this.anchorPt)
  }

  get elements(): Element[] {
    return this.drawings.flatMap((s) => s.elements);
  }

  get points(): Pt[] {
    return this.drawings.flatMap((s) => s.points);
  }

  get chains(): Chain[] {
    return this.drawings.flatMap((s) => s.chains);
  }
}

function group(items: Drawing[]) {
  var newLabels = new Map();
  for (let it of items)
    for (let pair of it.labels) newLabels.set(pair[0], pair[1]);
  return new Group(
    items[0].color,
    items.flatMap((it) => it.drawings),
    newLabels
  );
}

export { group };
